export default __webpack_public_path__ + "static/media/ee45b536-6492-49ce-98c2-36f9b48e9327.267758bd.jpg";